import React from 'react';
import { useIntl } from 'react-intl';
import { fieldClasses } from '../../FormField.styled';
import FormError from '../form-error';
import { FormFooterSC, HelpText } from './form-footer.styled';

interface FormFooterProps {
  error?: string | boolean;
  caption?: string;
  currentLength?: number;
  maxLength?: number;
}

const FormFooter: React.FunctionComponent<FormFooterProps> = ({
  error,
  caption,
  currentLength,
  maxLength,
}) => {
  const { formatMessage } = useIntl();
  const shown = error || caption || maxLength;

  if (!shown) {
    return null;
  }

  return (
    <FormFooterSC className={fieldClasses.footer}>
      {error ? (
        <FormError>{formatMessage({ id: error as any })}</FormError>
      ) : caption || maxLength ? (
        <HelpText display="body3">{caption}</HelpText>
      ) : null}
      {maxLength !== undefined ? (
        <HelpText display="body3">{`${currentLength ?? 0}/${maxLength}`}</HelpText>
      ) : null}
    </FormFooterSC>
  );
};

export default React.memo(FormFooter);
